// Parameter Block - API parameter documentation
class ParameterBlock {
  static get toolbox() {
    return {
      title: 'Parameter',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7V4h16v3"></path><path d="M9 20h6"></path><path d="M12 4v16"></path></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      name: data.name || 'parameter',
      type: data.type || 'string',
      required: data.required || false,
      description: data.description || '',
      defaultValue: data.defaultValue || ''
    };
    this.readOnly = readOnly;
    this.wrapper = null;
    this.types = config?.types || ['string', 'number', 'boolean', 'object', 'array'];
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="p-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800" data-testid="parameter-block">
        <div class="flex items-center gap-2 mb-2">
          <code class="param-name px-2 py-0.5 bg-slate-200 dark:bg-slate-700 rounded text-sm font-mono text-slate-900 dark:text-white" contenteditable="${!this.readOnly}">${this.data.name}</code>
          ${!this.readOnly ? `
            <select class="type-select text-xs px-2 py-1 rounded border bg-white dark:bg-slate-900">
              ${this.types.map(t => `<option value="${t}" ${this.data.type === t ? 'selected' : ''}>${t}</option>`).join('')}
            </select>
            <label class="flex items-center gap-1 text-xs text-slate-500">
              <input type="checkbox" class="required-check" ${this.data.required ? 'checked' : ''} />
              Required
            </label>
          ` : `
            <span class="text-xs px-2 py-0.5 rounded bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400">${this.data.type}</span>
            ${this.data.required ? '<span class="text-xs px-2 py-0.5 rounded bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400">Required</span>' : ''}
          `}
        </div>
        <div class="param-desc text-sm text-slate-600 dark:text-slate-400" contenteditable="${!this.readOnly}" data-placeholder="Description...">${this.data.description}</div>
        ${this.data.defaultValue || !this.readOnly ? `
          <div class="mt-2 text-xs text-slate-500">
            Default: <code class="param-default px-1 py-0.5 bg-slate-200 dark:bg-slate-700 rounded" contenteditable="${!this.readOnly}">${this.data.defaultValue || 'none'}</code>
          </div>
        ` : ''}
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelector('.param-name')?.addEventListener('input', (e) => {
        this.data.name = e.target.textContent;
      });
      this.wrapper.querySelector('.type-select')?.addEventListener('change', (e) => {
        this.data.type = e.target.value;
        this._render();
      });
      this.wrapper.querySelector('.required-check')?.addEventListener('change', (e) => {
        this.data.required = e.target.checked;
        this._render();
      });
      this.wrapper.querySelector('.param-desc')?.addEventListener('input', (e) => {
        this.data.description = e.target.innerHTML;
      });
      this.wrapper.querySelector('.param-default')?.addEventListener('input', (e) => {
        this.data.defaultValue = e.target.textContent;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default ParameterBlock;
